"use client";

import React from "react";
import { ClerkProvider as _ClerkProvider } from "@clerk/nextjs";

import { ruRU } from "@/app/localization/clerk.ru";
import endpoints from "@/constants/endpoints";

import { useRedirectUrl } from "../shared/hooks/useRedirectUrl";
import { useUrl } from "../shared/hooks/useUrl";
import { useNonceStore } from "../stores/nonce";

//

export interface ClerkProviderProps {
  children?: React.ReactNode;
}

//

export const ClerkProvider: React.FC<ClerkProviderProps> = ({ children }) => {
  const nonce = useNonceStore((s) => s.nonce);
  const url = useUrl();
  const params = useRedirectUrl();

  params.setRedirectUrl(url);
  const signInUrl = endpoints.findPath("signIn");
  const afterSignOutUrl = signInUrl + "?" + params.toString();

  return (
    <_ClerkProvider localization={ruRU} nonce={nonce} dynamic afterSignOutUrl={afterSignOutUrl}>
      {children}
    </_ClerkProvider>
  );
};
